"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyCodes = void 0;
exports.CurrencyCodes = [
    'GBP',
    'GBX',
    'AUD',
    'AUX',
    'EUR',
    'SEK',
];
